import React, { useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import ChronusApi from '../../../../services/ChronusApi';
import i18n from '../../../../utils/ChrI18n';
import * as viewRenderHelper from './viewRenderHelper';
import { formatToISODate } from '../../Utils/commonUtils';

const eventBlockDisplay = "block";
const dayGridMonth = "dayGridMonth";

const Calendar = props => {
  const fetchEvents = (fetchInfo, successCallback) => {
    ChronusApi.getUrlJSON(
      props.eventsFetchUrl,
      {
        initialDate: formatToISODate(
          new Date((fetchInfo.start.getTime() + fetchInfo.end.getTime()) / 2)
        ),
        ...{
          startDate: fetchInfo.startStr,
          endDate: fetchInfo.endStr
        },
        ...props.additionalEventsFetchParams
      }
    ).then(response => {
      successCallback(response);
    }).catch(_error => {
      ChronusValidator.ErrorManager.ShowPageFlash(false, i18n.t("common_text.error_msg.something_went_wrong"));
    });
  }

  useEffect(() => {
    viewRenderHelper.handleCalendarMount(props.containerRef, props.todayButtonTooltip);

    const handleClick = event => {
      if(event.target.closest('.fc-toolbar-title'))
        props.setShowMonthPicker(true);
    };

    const calendarContainer = props.containerRef.current;
    calendarContainer.addEventListener('click', handleClick);

    return () => calendarContainer.removeEventListener('click', handleClick);
  }, []);

  useEffect(() => {
    viewRenderHelper.setCalendarElementHeight(props.calendarRef, props.containerRef);
  });

  return(
    <>
      <FullCalendar
        ref={ props.calendarRef }
        firstDay={ 1 }
        initialDate={ props.initialDate }
        timeZone={ props.timeZone }
        weekends={ true }
        selectable={ false }
        dayMaxEventRows={ 3 }
        events={ fetchEvents }
        fixedWeekCount={ false }
        plugins={ [dayGridPlugin, momentTimezonePlugin] }
        initialView={ dayGridMonth }
        eventDisplay={ eventBlockDisplay }
        eventContent={ props.eventRendererFn }
        eventClick={ props.handleEventClick }
        titleFormat={ viewRenderHelper.getTitleFormat }
        eventDidMount={ _info => viewRenderHelper.handleEventMount(props.containerRef) }
        moreLinkContent={ viewRenderHelper.renderMoreLink }
        headerToolbar={ viewRenderHelper.getHeaderToolbar }
        buttonText={ viewRenderHelper.headerToolbarButtonsText }
        dayHeaderContent={ viewRenderHelper.getDayHeaderContent }
        dayPopoverFormat={ viewRenderHelper.getDayPopoverFormat }
        loading={ _isLoading => viewRenderHelper.toggleLoader() }
        windowResize={ () => viewRenderHelper.setCalendarElementHeight(props.calendarRef, props.containerRef) }
      />
      { props.children({calendarRef: props.calendarRef}) }
    </>
  )
};

export default React.memo(Calendar);